export default __webpack_public_path__ + "static/media/philippines.56a0a565.mp3";